import React from "react";

function AnnotationItem({ editing }) {
  return (
    <div className="FW-content" id="annotatable">
      {editing ? <p>(No options to edit)</p> : <p>Annotatable item</p>}
    </div>
  );
}

export default AnnotationItem;
